var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"login_flow_layer"},[_c('div',{staticClass:"login_container"},[_c('div',{staticClass:"login_title"},[_vm._v(_vm._s(_vm.$t('Login.LoginTitle')))]),_c('Login',{on:{"succeed":_vm.rb}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }